import type { IIconsButtonProps } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

type SaveSearchButtonProps = Required<Pick<IIconsButtonProps, "dataAutomation" | "onClick">> &
    Partial<Pick<IIconsButtonProps, "isDisabled" | "type" | "className" | "iconSize">>;

const SaveSearchButton = ({ type = "primary", ...buttonProps }: SaveSearchButtonProps) => {
    return (
        <IconButton
            type={type}
            iconName="diskette-shape"
            {...buttonProps}
        >
            {translate("si.lead_gen_filters.button.save-filters")}
        </IconButton>
    );
};

export default SaveSearchButton;
